


































import { defineComponent, PropType } from '@vue/composition-api';
import ALink from '@/components/common/a-link/a-link.vue';
import { useGetImageUrl } from '../hooks/strategy-tooltip';
import { StrategyOption } from '../consts';

const name = 'ttam-bid-strategy-tooltip';
// 动态加载图片
const bidStrategyImgs = require.context('@tt4b/ttam-assets/src/images/bid-strategy');

export default defineComponent({
  name,
  components: {
    ALink,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    strategyType: {
      type: Object as PropType<StrategyOption>,
      required: true,
    },
    learnMore: {
      type: String,
      default: '/help/article?aid=9685',
    },
  },
  setup() {
    function getImg(type) {
      return bidStrategyImgs(useGetImageUrl(type));
    }

    return {
      getImg,
      name,
    };
  },
});
